// DatePickerModal.js
import React, { useEffect, useMemo, useState } from 'react';
import { Modal, View, TouchableOpacity } from 'react-native';
import DateTimePicker from 'react-native-ui-datepicker';
import moment from 'moment';
import FadeTransition from '../fadeTransition';
import { useCssStyle } from '../../customHook/getCssStyle';
import dayjs from 'dayjs';
import { CustomModal } from '../customModal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const DatePickerModal = ({
  onClose,
  onDateChange,
  selectedDate,
  maxDate,
  minDate,
  availableDates
}) => {

  const getStyles = useCssStyle();
  // const insets = useSafeAreaInsets();

  const [date, setDate] = useState(null);

  const handleDateSelect = (date) => {

    const formattedDate = dayjs(date.date).format('YYYY-MM-DD');
    onDateChange(formattedDate);
  }

  useEffect(() => {
    if (selectedDate) {
      setDate(dayjs(selectedDate));
    }
  }, [selectedDate]);

  const availableDateSet = useMemo(() => {
    if (!availableDates || availableDates.length === 0) return null;

    return new Set(
      availableDates.map(d => dayjs(d).format('YYYY-MM-DD'))
    );
  }, [availableDates]);

  const disabledDates = useMemo(() => {
    if (!availableDateSet) return undefined;

    return (date) => {
      const formatted = dayjs(date).format('YYYY-MM-DD');
      return !availableDateSet.has(formatted);
    };
  }, [availableDateSet]);




  const primaryTextStyle = getStyles(["DateTimePicker_primaryTextStyle"])
  const secondaryTextStyle = getStyles(["DateTimePicker_secondaryTextStyle"])
  const selectedTextStyle = getStyles(["DateTimePicker_selectedTextStyle"])

  return (

    <CustomModal onRequestClose={onClose}>
          <View style={getStyles(['datePickerWrapper'])}>
            <View style={getStyles(['datePickerWrapper_child'])}>
              <DateTimePicker
                mode="single"
                date={date}
                onChange={handleDateSelect}

                headerTextStyle={primaryTextStyle}
                headerButtonColor={primaryTextStyle.color}

                monthContainerStyle={getStyles(['datePickerWrapper_child_innerContainer'])}
                yearContainerStyle={getStyles(['datePickerWrapper_child_innerContainer'])}

                weekDaysTextStyle={secondaryTextStyle}
                calendarTextStyle={secondaryTextStyle}


                selectedTextStyle={selectedTextStyle}
                selectedItemColor={selectedTextStyle.backgroundColor}

                disabledDates={disabledDates}

                // minDate={minDate ? moment(minDate).startOf('day').toDate() : undefined}
                maxDate={maxDate ? moment(maxDate).endOf('day').toDate(): undefined}
              />
            </View>
          </View>
      </CustomModal>
  );
};

export default DatePickerModal;
